import React from "react";
import { InventoryInFormModal } from "../InventoryInFormModal";

export function PurchaseFromVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <InventoryInFormModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      sourceType="Purchase_From_Vendor"
      labelKey="inventory.purchaseFromVendor"
    />
  );
}
